export default __webpack_public_path__ + "static/media/summt.48d950b6.jpg";